import React from 'react';
import { Link } from 'react-router-dom';

const buttonData = [
  { to: '/home', label: 'Home', icon: 'home' },
  { to: '/process', label: 'Process', icon: 'cog' },
  { to: '/printer', label: 'Printer', icon: 'print' },
  { to: '/mould', label: 'Mould', icon: 'cube' },
  { to: '/melt', label: 'Melt', icon: 'fire' },
  { to: '/energyanalytics', label: 'Energy Analytics', icon: 'chart-pie' }
];

function NavigationButtons() {
  return (
    <div className="grid grid-cols-2 p-4 w-full 2xl:grid-cols-6 gap-4 lg:grid-cols-3 md:grid-cols-3 xl:grid-cols-5">
      {buttonData.map((button, index) => (
        <Link
          key={index}
          to={button.to}
          className="bg-gradient-to-br p-0.5 rounded-lg duration-300 from-blue-500 group hover:from-indigo-500 hover:scale-105 hover:shadow-lg hover:to-pink-500 overflow-hidden relative to-purple-600 transition-all"
        >
          <div className="flex bg-gray-900 h-12 justify-center rounded-md text-center w-full duration-300 group-hover:bg-opacity-80 items-center px-8 py-5 relative transition-all">
            <span className="mr-2">
              <i className={`fas text-white fa-${button.icon}`}></i>
            </span>
            <span className="text-sm text-white font-semibold">{button.label}</span>
          </div>
        </Link>
      ))}
    </div>
  );
}

export default NavigationButtons;